import type {ImageProcessing} from "#image-processing/image-processing"
import type {ImageProcessingNodes} from "@cm/image-processing-nodes"
import type {TypedImageData} from "@cm/utils/typed-image-data"
import type {Observable} from "rxjs"
import {of as observableOf} from "rxjs"

export type TransferListItem = ArrayBuffer
type IWebAssemblyWorkerManager = {
    invokeFunction<ResponseT>(functionName: string, args: any[], transfers?: TransferListItem[]): Observable<ResponseT>
}

export class ImageProcessingActions {
    constructor(private workerManager: IWebAssemblyWorkerManager) {}

    encodeEXR(image: TypedImageData, bitDepth: 16 | 32 = 16): Observable<Uint8Array> {
        return this.workerManager.invokeFunction("encodeEXR", [image, bitDepth])
    }

    decodeEXR(fileData: Uint8Array): Observable<TypedImageData> {
        return this.workerManager.invokeFunction("decodeEXR", [fileData])
    }

    encodeTIFF(image: TypedImageData): Observable<Uint8Array> {
        return this.workerManager.invokeFunction("encodeTIFF", [image])
    }

    encodePNG(image: TypedImageData): Observable<Uint8Array> {
        return this.workerManager.invokeFunction("encodePNG", [image])
    }

    encodeJPEG(image: TypedImageData): Observable<Uint8Array> {
        return this.workerManager.invokeFunction("encodeJPEG", [image])
    }

    decodeImage(fileData: Uint8Array): Observable<TypedImageData> {
        return this.workerManager.invokeFunction("decodeImage", [fileData])
    }

    evalGraph<T extends ImageProcessingNodes.Node>(graph: T): Observable<ImageProcessing.EvaledTypeOf<T>> {
        return this.workerManager.invokeFunction("evalImageProcessingGraph", [graph])
    }

    convertToUint8RGBA(image: TypedImageData): Observable<Uint8Array | null> {
        if (!(image.data && image.width && image.height)) {
            return observableOf(null)
        } else if (image.dataType === "uint8" && image.channelLayout === "RGBA") {
            return observableOf(new Uint8Array(image.data.buffer, image.data.byteOffset, image.data.byteLength))
        } else {
            return this.workerManager.invokeFunction("convertToUint8RGBA", [image])
        }
    }
}
